import { ArchiveMutation } from "../../hooks/useArchiveState";
import { PatientDiagnosisControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchivePatientDiagnoses = () =>
  useMutationWithLoading(
    async (param: {
      patientDiagnosisId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new PatientDiagnosisControllerApi(
        getConfigObject()
      ).updatePatientDiagnosisArchiveStatus(
        param.patientDiagnosisId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );

  export const useArchivePatientDiagnosesMutation = () =>
    useMutationWithLoading(
      async (param: ArchiveMutation) =>
        new PatientDiagnosisControllerApi(
          getConfigObject()
        ).updatePatientDiagnosisArchiveStatus(
          param.id,
          param.status,
          param.xTENANTID //xTENANTID
        )
    );